module.exports = __webpack_public_path__ + "img/gwen-ava.7a16b48.png";